export function playOnload() {
    const videos = document.querySelectorAll("video.play-onload");
    window.addEventListener("load", playVideo);
    function playVideo() {
        [...videos].forEach(video => {
            video.play();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/play-onload.js